import styled from "styled-components";

export const ContainerIconeInconsistencia = styled.span`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: var(--danger-color);
    cursor: help;
`
